// extracted by mini-css-extract-plugin
module.exports = {"onboarding":"Onboarding_onboarding__3soyj","SolarSystem":"Onboarding_SolarSystem__rXiZI","worldtour":"Onboarding_worldtour__1xuQu"};